import { Typography } from '@chilecompra/react-kit/components'

import { Container, Divider } from '../Cfmp.styles'

/**
 * The CfmpHeader component.
 */
export const CfmpHeader = () => (
  <Container direction="column" spacing={2}>
    <Typography fontWeight="bold" variant="h2">
      Registrar compra fuera de Mercado Público
    </Typography>

    <Typography variant="body2">
      Registra las compras realizadas fuera de Mercado Público para cumplir la normativa y asegurar
      la trazabilidad y visibilidad de tu proceso.
    </Typography>

    <Divider margin="16px 0 0" />
  </Container>
)
